import { css } from "@emotion/react";

export const checkboxSkeleton = css`
  width: 60%;
`;

export const headingSkeleton = css`
  width: 80%;
`;

export const commonIngredientsContainer = css`
  margin: 1rem 0;
`;

export const checkbox = css`
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
`;
